import { render, staticRenderFns } from "./addAddition.vue?vue&type=template&id=2f54e19d&scoped=true&"
import script from "./addAddition.vue?vue&type=script&lang=js&"
export * from "./addAddition.vue?vue&type=script&lang=js&"
import style0 from "./addAddition.vue?vue&type=style&index=0&id=2f54e19d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f54e19d",
  null
  
)

export default component.exports